import React from 'react';
import SearchInput from './SearchInput';
import OptionsList from './OptionsList';

const Dropdown = ({ 
  dropdownRef, 
  dropdownPosition, 
  showSearch, 
  searchValue, 
  onSearchChange, 
  filteredOptions, 
  selectedValues, 
  onToggleOption 
}) => {
  return (
    <div 
      ref={dropdownRef}
      className={`
        absolute w-full bg-white border border-gray-200 rounded-lg overflow-y-auto mt-[-50px]
        ${dropdownPosition === 'top' ? 'bottom-[230%] mb-1' : 'top-[240%]'}
      `}
      style={{
        maxHeight: '300px',
        minWidth: '250px',
        zIndex: 1001
      }}
    >
      {showSearch && (
        <SearchInput 
          value={searchValue} 
          onChange={onSearchChange} 
        />
      )}
      <OptionsList 
        options={filteredOptions}
        selectedValues={selectedValues}
        onToggleOption={onToggleOption}
        showSearch={showSearch}
      />
    </div>
  );
};

export default Dropdown;